import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Users } from './users.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }

  Create(userObj: any) {
    return this.http.post(this.global.APIURL + "identity/register2", userObj)
  }

  Update(userObj: any) {
    return this.http.put(this.global.APIURL + "users", userObj)
  }

  getWebUsers() {
    return this.http.get<Users[]>(this.global.APIURLV2 + "users/getwebadminusers")
  }

  getWebAssistanceUsers() {
    return this.http.get<Users[]>(this.global.APIURLV2 + "users/getassistance")
  }

  UpdateUserTransferBallance(userId: string) {
    return this.http.put(this.global.APIURLV2 + "users/activateanddeactivatetransfereballance/" + userId, null)
  }
  UpdateUserQrCodeTransActive(userId: string) {
    return this.http.put(this.global.APIURLV2 + "users/activateanddeactivateQrCodeTrans/" + userId, null)
  }

  UpdateAdminInfo(obj: any) {
    return this.http.put(this.global.APIURLV2 + "users/updateadmininfo", obj);
  }

  logOutFromAll(userId: string) {
    return this.http.put<any>(this.global.APIURL + "users/logoutall/" + userId, null);
  }

  getUsersByRole(roleName: any) {
    return this.http.get<Users[]>(this.global.APIURLV2 + "users/getusersbyrole?roleName=" + roleName)
  }

  getUsersBalance() {
    return this.http.get<Users[]>(this.global.APIURLV2 + "users/getusersbalance")
  }
}
